import { Scroll, Stack } from '@/components/layout';
import { StackLayoutProps } from '@/components/layout/stack/types';
import { useDailyBackground, useScaling } from '@/hooks';
import { ImageBackground, ImageStyle, Platform, StyleSheet } from 'react-native';

import { createContext } from 'react';
import { KeyboardAvoidingView } from 'react-native-keyboard-controller';

type AuthContainerContextType = {};

const AuthContainerContext = createContext<AuthContainerContextType>({});

export const AuthContainerRoot = ({ children, ...props }: StackLayoutProps) => {
  const { scale } = useScaling();
  const backgroundSource = useDailyBackground();

  return (
    <KeyboardAvoidingView behavior="padding" style={styles.keyboardAvoidingView}>
      <AuthContainerContext.Provider value={{}}>
        <ImageBackground
          style={styles.background}
          imageStyle={Platform.OS === 'web' ? styles.webBackgroundFill : undefined}
          source={backgroundSource}>
          <Scroll bounces={false} flexGrow={1} showsVerticalScrollIndicator={false} {...props}>
            <Stack flex={1} align="center" justify="center" width="100%" paddingX={scale(24)}>
              {children}
            </Stack>
          </Scroll>
        </ImageBackground>
      </AuthContainerContext.Provider>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  background: {
    flex: 1,
  },
  keyboardAvoidingView: {
    flex: 1,
    width: '100%',
  },
  webBackgroundFill: {
    width: '100%',
    height: '100vh',
  } as unknown as ImageStyle,
});
